import { component } from "picoapp";

export const cartToggle = component((node: HTMLElement) => {
  const updateCartItems = (event: CustomEvent) => {
    const cartItemCount = event.detail?.cart?.cart?.item_count;
    if (isNaN(cartItemCount)) return false;
    node.textContent = cartItemCount;
    if (cartItemCount === 0) {
      node.style.display = "none";
    } else {
      node.style.display = "flex";
    }
  };

  document.addEventListener("rebuy:cart.change", updateCartItems);

  return () => {
    document.removeEventListener("rebuy:cart.change", updateCartItems);
  };
});
